<template>
  <CoreCard>
    <EmptyPageCard
      :customImage="mrsDrunkieImage"
      class="py-5">
      <template #heading>
        <span>{{ $t("common.messages.page_not_found_heading") }}</span>
      </template>
      <template #subheading>
        <span v-if="!isEmbeddedFlagActive">
          {{ $t("common.messages.page_not_found_subheading") }}
        </span>
      </template>
      <template #buttons>
        <div
          v-if="!isEmbeddedFlagActive"
          class="d-flex flex-grow-0 align-items-center justify-content-center">
          <CoreButton
            :label="$t('common.messages.go_home')"
            :onClickHandler="onClickButton"
            class="flex-grow-0 mx-0 mt-2 mb-0"
            template="default"
            data-test="back-to-landing-button" />
        </div>
      </template>
    </EmptyPageCard>
  </CoreCard>
</template>

<script>
import CoreButton from "./Button.vue"
import CoreCard from "./CoreCard.vue"
import EmptyPageCard from "./EmptyPageCard.vue"
import mrs_drunkie from '../assets/images/mrs_drunkie.svg'

export default {
  name: "PageNotFound",
  components: {
    CoreButton,
    CoreCard,
    EmptyPageCard,
  },
  props: {
    isEmbeddedFlagActive: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      mrsDrunkieImage: mrs_drunkie,
    }
  },
  methods: {
    onClickButton () {
      this.$router.push({path: '/'})
    },
  },
}
</script>

<style scoped>
.min-height-page {
  min-height: 30rem;
}
</style>
